import React from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import { plural } from '../utils';
import styles from '../Recovery.module.css';

/**
 * Um intervalo livre de um profissional: "14:00 às 16:00, Dra. Ana, 120 min"
 * e quantas pessoas combinam. O card inteiro abre a lista de pessoas.
 */
function OpportunityCard({ interval, onSelect }) {
  const count = Number(interval.candidateCount) || 0;
  const meta = [interval.professionalName, `${interval.minutes} min`].filter(Boolean).join(' · ');

  return (
    <button type="button" className={styles.opportunity} onClick={() => onSelect(interval)}>
      <span className={styles.opportunityTime}>{interval.start} às {interval.end}</span>
      <span className={styles.opportunityMeta}>{meta}</span>
      <span className={styles.opportunityFooter}>
        <span className={`${styles.pill} ${count === 0 ? styles.pillMuted : ''}`}>
          <PeopleOutlineIcon style={{ fontSize: 14 }} />
          {count === 0 ? 'Ninguém para chamar' : plural(count, 'pessoa', 'pessoas')}
        </span>
        <span className={styles.opportunityArrow}>
          <ChevronRightIcon style={{ fontSize: 18 }} />
        </span>
      </span>
    </button>
  );
}

export default OpportunityCard;
